module.exports = __webpack_public_path__ + "img/MYT.15b81ac6.svg";